import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import format from "date-fns/format";

import * as codeActions from "../../../actions/codeActions";
import * as projectActions from "../../../actions/projectActions";

import DropdownSearch from "../../common/DropdownSearch";
import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import Loading from "../../common/Loading";

import ReportFilters from "../ReportFiltersComponent";
import { downloadCSV } from "../utils";

import columns from "./ActiveProjects.columns";

function ActiveProjects({ loading, codes, actions, projects }) {
  const [filters, setFilters] = useState({
    department: [],
    project_manager: [],
    call_type: []
  });

  const handleFetchClick = () => {
    const query = {};
    if (filters.department.length) {
      query.department = filters.department.map((s) => s.value);
    }
    if (filters.project_manager) {
      query.project_manager = filters.project_manager.map((s) => s.value);
    }
    if (filters.call_type) {
      query.call_type = filters.call_type.map((s) => s.value);
    }
    actions.loadActiveProjects(query);
  };

  const handleResetClick = () => {
    setFilters({
      department: [],
      project_manager: [],
      call_type: []
    });
    actions.clearProjects();
  };

  const handleCSVExportClick = () => {
    downloadCSV(
      `IrisProjects-${format(new Date(), "yyyy_MM_dd")}`,
      projects,
      columns
    );
  };

  const handleChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      .filter((code) => code.entity === entity && code.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));
    return orderBy(
      codeOptions,
      [(option) => option.label.toLowerCase()],
      "order"
    );
  };

  return (
    <React.Fragment>
      <ReportFilters
        onFetchClick={handleFetchClick}
        onResetClick={handleResetClick}
        title="Active Projects"
        loading={loading}
        disabled={loading}
        csvExportAvailable
        onCSVExport={handleCSVExportClick}
        exportDisabled={loading || !projects.length}
      >
        <Row>
          <Col md={4}>
            <DepartmentSelect
              isMulti
              label="Department"
              placeholder="Select"
              value={filters.department || null}
              onChange={(e) => handleChange("department", e)}
            />
          </Col>
          <Col md={4}>
            <UserSelect
              isMulti
              label="Project Manager"
              placeholder="Select"
              value={filters.project_manager || null}
              onChange={(e) => handleChange("project_manager", e)}
            />
          </Col>
          <Col md={4}>
            <DropdownSearch
              isMulti
              rowStyles={{ marginTop: 0 }}
              label="Call Type"
              placeholder="Select"
              name="call_type"
              onChange={(field, value) => handleChange(field, value)}
              value={filters.call_type || []}
              data={generateCodeOptions("Call", "type")}
            />
          </Col>
        </Row>
      </ReportFilters>
      <Row>
        <div
          className="content-wrapper"
          style={{ padding: "15px 15px ", borderRadius: "0.5rem" }}
        >
          <ReactTable
            loading={loading}
            LoadingComponent={() => <Loading active={loading} />}
            columns={columns}
            data={projects}
            defaultPageSize={10}
            noDataText="No Projects Found"
          />
        </div>
      </Row>
    </React.Fragment>
  );
}

ActiveProjects.propTypes = {
  codes: PropTypes.array,
  loading: PropTypes.bool,
  actions: PropTypes.object,
  projects: PropTypes.array
};

ActiveProjects.defaultProps = {
  codes: [],
  projects: []
};

const mapStatesToProps = (state) => ({
  codes: state.reducers.codes,
  projects: state.reducers.projects,
  loading: state.reducers.loading
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...codeActions,
      ...projectActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(ActiveProjects);
